//基础通用web功能
export default [
  {
    //维护 总览
    path: '/figma',
    name: 'figma',
    component: () => import('@/page/figma/index.vue')
  }, {
    //维护 数据分析
    path: '/figma2',
    name: 'figma2',
    component: () => import('@/page/figma/index2.vue')
  }, {
    //维护  警报和事件
    path: '/figma3',
    name: 'figma3',
    component: () => import('@/page/figma/index3.vue')
  }, {
    //维护  
    path: '/figma4',
    name: 'figma4',
    component: () => import('@/page/figma/index4.vue')
  }, {
    //维护
    path: '/figma5',
    name: 'figma5',
    component: () => import('@/page/figma/index5.vue')
  }, {
    //维护
    path: '/figma6',
    name: 'figma6',
    component: () => import('@/page/figma/index6.vue')
  },
  {
    path: '/economicAnalysis',
    name: 'economicAnalysis',
    component: () =>
      import('@/page/confluence/economicAnalysis.vue')
  },
  {
    path: '/pumpRunInfo',
    name: 'pumpRunInfo',
    component: () =>
      import('@/page/event/pumpInfo.vue')
  },
  {
    path: '/scanCode',
    name: 'scanCode',
    component: () =>
      import('@/page/scanCode/scanCode.vue')
  },
  {
    path: '/scanCodeDetail',
    name: 'scanCodeDetail',
    component: () =>
      import('@/page/scanCode/scanCodeDetail.vue')
  },
  {
    path: '/huapuHome',
    name: 'huapuHome',
    component: () =>
      import('@/page/projectDingZhi/huapu/华普home.vue')
  },
  {
    path: '/branch',
    name: 'branch',
    component: () =>
      import('@/page/confluence/branch.vue')
  },
  {
    //能流图
    path: '/energyStream',
    name: 'energyStream',
    component: () =>
      import('@/page/yuexin/energyStream.vue')
  },
  {
    //变损设置
    path: '/configuration',
    name: 'configuration',
    component: () =>
      import('@/page/yuexin/configuration.vue')
  },
  {
    //变损列表
    path: '/lossAnalysis',
    name: 'lossAnalysis',
    component: () =>
      import('@/page/yuexin/lossAnalysis.vue')
  },
  {
    //线损列表
    path: '/lineAnalysis',
    name: 'lineAnalysis',
    component: () =>
      import('@/page/yuexin/lineAnalysis.vue')
  },
  {
    //地理信息
    path: '/webMap',
    name: 'webMap',
    component: () =>
      import('@/page/webMap/webMap.vue')
  },
  {
    //看板demo
    path: '/unitPower',
    name: 'unitPower',
    component: () =>
      import('@/page/demo/temp.vue')
  },
  {
    //能耗分项
    path: '/energyTypePower',
    name: 'energyTypePower',
    component: () =>
      import('@/page/energy/energyTypePowerDifference.vue')
  },
  {
    //设备台账demo
    path: '/deviceArchives',
    name: 'deviceArchives',
    component: () =>
      import('@/page/demo/temp3.vue')
  },
  {
    //设备列表demo
    path: '/deviceList',
    name: 'deviceList',
    component: () =>
      import('@/page/demo/temp2.vue')
  },
  {
    //Kate上传
    path: '/manualUpload',
    name: 'manualUpload',
    component: () =>
      import('@/page/kate/kateUpload.vue')
  },
  {
    //华普定制看板
    path: '/kanban',
    name: 'kanban',
    component: () =>
      import('@/page/projectDingZhi/huapu/hpPowerUnit.vue')
  },
  {
    //华普定制看板
    path: '/kanban2',
    name: 'kanban2',
    component: () =>
      import('@/page/projectDingZhi/yuenan/kanban.vue')
  },
  //	{
  //务联能耗排名
  // 	path:'/energyRanking',
  // 	name:'energyRanking',
  // 	component: () =>
  // 		import('@/page/wulian/newEnergyRanking.vue')
  // },
  {
    //务联设备管理
    path: '/deviceManager',
    name: 'deviceManager',
    component: () =>
      import('@/page/wulian/deviceManager.vue')
  },
  {
    //svg图形列表
    path: '/svgList',
    name: 'svgList',
    component: () =>
      import('@/page/svg/svgList.vue')
  }, {
    path: '/singleSvg',
    name: 'singleSvg',
    component: () =>
      import('@/page/svg/singleSvg.vue')
  }, {   //抄表计量
    path: '/singleSvg2',
    name: 'singleSvg2',
    component: () =>
      import('@/page/svg/singleSvg2.vue')
  }, {
    //实时曲线
    path: '/virtualDeviceRTCurve',
    name: 'virtualDeviceRTCurve',
    component: () =>
      import('@/page/rtvalue/virtualDeviceRTCurve.vue')
  }, {
    //实时表格
    path: '/virtualDeviceRTValue',
    name: 'virtualDeviceRTValue',
    component: () =>
      import('@/page/rtvalue/virtualDeviceRTValue.vue')
  }, {
    //历史曲线
    path: '/historyCurve',
    name: 'historyCurve',
    component: () =>
      import('@/page/history/historyCurve.vue')
  }, {
    //历史表格
    path: '/historyValue',
    name: 'historyValue',
    component: () =>
      import('@/page/history/historyValue.vue')
  }, {
    //历史示值
    path: '/tcHistoryShowValue',
    name: 'tcHistoryShowValue',
    component: () =>
      import('@/page/history/tcHistoryShowValue.vue')
  }, {
    path: '/deviceReport', //报表查询
    name: 'deviceReport',
    component: () =>
      import('@/page/report/deviceReport.vue')
  }, {
    //自定义报表
    path: '/customizeReport',
    name: 'customizeReport',
    component: () =>
      import('@/page/report/customizeReport.vue')
  }, {
    //时间对标
    path: '/timeBenchmark',
    name: 'timeBenchmark',
    component: () =>
      import('@/page/history/timeBenchmark.vue')
  }, {
    //设备对标
    path: '/deviceBenchmark',
    name: 'deviceBenchmark',
    component: () =>
      import('@/page/history/deviceBenchmark.vue')
  }, {
    //趋势分析
    path: '/historyAnalysis',
    name: 'historyAnalysis',
    component: () =>
      import('@/page/history/historyAnalysis.vue')
  }, {
    //趋势分析（新）
    path: '/newhistoryAnalysis',
    name: 'newhistoryAnalysis',
    component: () =>
      import('@/page/history/newhistoryAnalysis.vue')
  }, {
    //事件
    path: '/events',
    name: 'events',
    component: () =>
      import('@/page/event/elEvent.vue')
  }, {
    //实时事件
    path: '/realTime',
    name: 'realTime',
    component: () =>
      import('@/page/event/realTime.vue')
  }, {
    //事件新界面
    path: '/events2',
    name: 'events2',
    component: () =>
      import('@/page/event/elEvent.vue')
  }, {
    path: '/channel', //通道管理
    name: 'channel',
    component: () =>
      import('@/page/channel/channel.vue')
  },
  {
    //各种类型排名
    path: '/defineRank',
    name: 'defineRank',
    component: () =>
      import('@/page/yuexin/defineRank.vue')
  },
  {
    //班组管理
    path: '/teamAssessment',
    name: 'teamAssessment',
    component: () =>
      import('@/page/teamAssessment/teamAssessment.vue')
  },
  {
    //新班组管理
    path: '/newteamAssessment',
    name: 'teamAssessment',
    component: () =>
      import('@/page/teamAssessment/newteamAssessment.vue')
  }, {
    //班组考核
    path: '/AssessmentStatistics',
    name: 'AssessmentStatistics',
    component: () =>
      import('@/page/teamAssessment/AssessmentStatistics.vue')
  }, {
    //新班组考核
    path: '/newAssessmentStatistics',
    name: 'AssessmentStatistics',
    component: () =>
      import('@/page/teamAssessment/newAssessmentStatistics.vue')
  }, {
    //在线视频播放
    path: '/onlineCamera',
    name: 'onlineCamera',
    component: () =>
      import('@/page/camera/onlineCamera.vue')
    //import('@/page/camera/IntranetCamera.vue')
  }, {
    //内网摄像头
    path: '/IntranetCamera',
    name: 'IntranetCamera',
    component: () =>
      import('@/page/camera/IntranetCamera.vue')
  }, {
    //在线视频播放
    path: '/videoConfig',
    name: 'videoConfig',
    component: () =>
      import('@/page/videoConfig/videoConfig.vue')
  }, {
    //组播
    path: '/multicast',
    name: 'multicast',
    component: () =>
      import('@/page/control/multicast.vue')
  }, {
    //设备遥控
    path: '/deviceControl',
    name: 'deviceControl',
    component: () =>
      //import('@/page/control/deviceControl.vue')
      //务联
      import('@/page/control/wulianDeviceControl.vue')
  }, {
    //组播定义
    path: '/queueGroup',
    name: 'queueGroup',
    component: () =>
      import('@/page/control/queueGroup.vue')
  }, {
    //组播定义
    path: '/queueGroup',
    name: 'queueGroup',
    component: () =>
      import('@/page/control/queueGroup.vue')
  }, {
    //APPsvg图
    path: '/appSvg',
    name: '/appSvg',
    component: () =>
      import('@/page/appPage/appSvg.vue')
  },
  {
    //APPsvg图
    path: '/process',
    name: 'process',
    component: () =>
      import('@/page/process/processData.vue')
  },
  {
    // 人工填报
    path: '/manualInputVariable',
    name: 'manualInputVariable',
    component: () => import('@/page/manualInputVariable/temp4')
  },
  {
    // 生产制造看板人工填报
    path: '/manufacturingKanban',
    name: 'manufacturingKanban',
    component: () => import('@/page/manufacturingKanban')
  }
]